//обновляем количество товара в корзине
getCartInfo = function () {
    $.ajax({
        url: '/catalog/getcartinfo',
        success: function (data) {
            var response = JSON.parse(data);
            $('.cart_count').html(response.cartItemsCount);
        }
    });
};

function getNumEnding(iNumber, aEndings) {
    var sEnding, i;
    iNumber = iNumber % 100;
    if (iNumber >= 11 && iNumber <= 19) {
        sEnding = aEndings[2];
    } else {
        i = iNumber % 10;
        switch (i) {
            case (1):
                sEnding = aEndings[0];
                break;
            case (2):
            case (3):
            case (4):
                sEnding = aEndings[1];
                break;
            default:
                sEnding = aEndings[2];
        }
    }
    return sEnding;
}

function formatNumber(number, decimals, dec_point, thousands_sep) {
    var i, j, kw, kd, km;
    if (isNaN(decimals = Math.abs(decimals))) {
        decimals = 2;
    }
    if (dec_point === undefined) {
        dec_point = ",";
    }
    if (thousands_sep === undefined) {
        thousands_sep = ".";
    }
    i = parseInt(number = (+number || 0).toFixed(decimals)) + "";
    if ((j = i.length) > 3) {
        j = j % 3;
    } else {
        j = 0;
    }
    km = (j ? i.substr(0, j) + thousands_sep : "");
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
    kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");
    return km + kw + kd;
}

function isInt(val) {
    return parseInt(val) == val;
}

(function ($) {
    $.fancyboxNotify = function (content, title, classes) {
        classes = (classes === undefined) ? '' : classes;
        var $content = content || $('<div></div>');
        var caption = typeof (title) !== 'undefined' ? title : '';
        var $fancyContent = $('<div></div>');
        $fancyContent.addClass('wrap-call');
        $fancyContent.addClass('modal');
        if (classes !== '') {
            $fancyContent.addClass(classes);
        }
        $fancyContent.append('<div class="caption">' + caption + '</div>');
        //console.log(content);
        $fancyContent.append($content);
        this.open = function (modal) {
            var _modal = modal || false;
            $.fancybox({
                modal: _modal,
                content: $fancyContent,
                margin: 0,
                padding: 0,
            });
        };
        return this;
    };
})($);
$(document).ready(function () {
//footer padding
    $('#page .content').css({
        'padding-bottom': $('footer').outerHeight()
    });
// hide/show placeholder on active input
    $('input, textarea').focus(function () {
        $(this).data('placeholder', $(this).attr('placeholder'))
        $(this).attr('placeholder', '');
    }).blur(function () {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });

//смена изображения товара при наведении
    $('.hover_animated').mouseenter(function () {
        $(this).attr('src', $(this).data('back_image'));
    }).mouseleave(function () {
        $(this).attr('src', $(this).data('front_image'));
    });

    getCartInfo();
//добавить в корзину
    var addToCart = function (e) {
        e.preventDefault();
        var formData = undefined;

        if ($(this).parents('form').length === 0) {
            formData = {
                CartItems: {
                    autoChair: 0,
                    heatType: 2,
                    itemType: $(this).data('type'),
                    size: 2,
                    itemId: $(this).data('id'),
                    isDiscounted: 0,
                    parent_id: 0,
                }
            };
        } else {
            formData = $(this).parents('form').serialize();
        }

        $.ajax({
            url: '/catalog/addtocart',
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (response) {
                getCartInfo();
                $('.js-add-to-cart-modal').fadeIn();
                $('.modal-shadow').fadeIn();
            },
            fail: function (xhr) {
                if (xhr.responseJSON !== undefined) {
                    const response = xhr.responseJSON;
                    if (response.message !== undefined) {
                        $('.modal-shadow').fadeOut();
                        $('.js-add-to-cart-modal').fadeOut().children(".bottom_wrapper").remove();
                        $.fancyboxNotify(undefined, response.message).open(false);
                    }
                }
            }
        });
    };
    $(".js-add-to-cart-modal .close-modal, .js-add-to-cart-modal .blank_btn").click(function (e) {
        e.preventDefault();
        $('.js-add-to-cart-modal').fadeOut();
        $('.modal-shadow').fadeOut();
    });
    $(document).on('keyup', function (e) {
        if (e.keyCode === 27) {
            $('.js-add-to-cart-modal').fadeOut();
            $('.modal-shadow').fadeOut();
        }
    });
    $('#add-to-cart').click(addToCart);//кнопка внутреняя товара
    $('html').on('click', '.js-add-to-cart', addToCart);

    //menu-button
    $('.js-menu-button').click(function () {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    });
    $('.mobile-catalog-menu').click(function () {
        let button = $('.js-catalog-btn');
        button.toggleClass('active');
        $(this).next().slideToggle().css('display', 'block');
    });
    $(".mobile-menu a.has-submenu.level-2").on('click', function (e) {
        e.preventDefault();
        $(this).parents("li").toggleClass('active');
    });
    // Sticky header menu
    (function () {
        var headerMenu = $('.header-menu');
        var headerContainer = $('.header');
        var headerMenuOffsetTop = headerContainer.outerHeight() - headerMenu.outerHeight();
        $(window).scroll(function () {
            var scroll = $(this).scrollTop();
            if (scroll >= headerMenuOffsetTop && !headerMenu.is('.fixed_menu')) {
                headerMenu.addClass('fixed_menu');
                headerContainer.addClass('sticky_menu');
                $('body').addClass('fixed_header__active');
            }
            if (scroll <= headerMenuOffsetTop && headerMenu.is('.fixed_menu')) {
                headerMenu.removeClass('fixed_menu');
                headerContainer.removeClass('sticky_menu');
                $('body').removeClass('fixed_header__active');
            }
        });
    })();
    $(".js-captcha-check").on('click', function (e) {
        e.preventDefault();
        let button = $(this);
        button.attr('disabled', 'disabled');
        grecaptcha.ready(function () {
            grecaptcha.execute('6Lc0G64ZAAAAAP20UwXSWCjKA9-KFcQdnwRDt5KB', {action: 'submit'}).then(function (token) {
                $.ajax({
                    url: '/captchacheck',
                    data: {
                        token: token,
                    },
                    type: 'post',
                    dataType: 'json',
                    success: function (response) {
                        if (response.success === 1) {
                            button.closest('form').submit();
                        } else {
                            var $em = $('<p class="errorMessage">Вероятно вы робот</p>');
                            setTimeout(function () {
                                $em.fadeOut(300, function () {
                                    $(this).remove();
                                });
                            }, 3000);
                            button.closest('form').append($em)
                        }
                        button.removeAttr('disabled');
                    },
                    fail: function (error) {
                        button.removeAttr('disabled');
                    }
                });
            });
        });
    })
});
